import {HttpException} from "./http.exception.js";

/**
 * 404 Not Found Exception
 */
export class NotFoundException extends HttpException {
    constructor(message: string = "Not Found", errorBody?: unknown, cause?: Error) {
        super(404, message, errorBody, cause);
    }
}
